module.exports = __webpack_public_path__ + "static/media/merm-fre.e6260b85.png";